import request from '@/plugins/request';

/**
 * 获取媒体视频列表（不分页）
 * @returns {Promise} - 返回Promise对象
 */
export function getMediaVideoList() {
  return request({
    url: '/fronted/media_video/getList',
    method: 'get'
  });
}

/**
 * 获取媒体视频详情
 * @param {string|number} id - 视频ID
 * @returns {Promise} - 返回Promise对象
 */
export function getMediaVideoDetail(id) {
  return request({
    url: `/fronted/media_video/${id}`,
    method: 'get'
  });
}
